import {extractTemplateSlides, Template} from "@reside/forms";

import {INCLUDE_IN_AUDIT_LOG_BLOCK} from "./consts";
import {
  filterVisibleFacilitySettingsBlocks,
  getFacilitySettingsBlockLabel,
} from "./facilitySettingsBlocks";
import {
  makeWorkflowBlockSectionId,
  makeWorkflowDocumentCategorySectionId,
  makeWorkflowDownloadEmptyPacketSectionId,
} from "./workflowSectionIds";

export type WorkflowNavItem = Readonly<{
  id: string;
  label: string;
}>;

export const getWorkflowDownloadEmptyPacketTitle = (
  workflowLabel: string,
): string => `Download Empty ${workflowLabel} Packet`;

export const extractWorkflowSettingsBlocks = (
  workflowTemplate: Template | undefined,
  mergedAnswers: Record<string, unknown>,
  isResideAdmin: boolean,
): any[] => {
  if (!workflowTemplate) {
    return [];
  }

  const extractedBlocks = extractTemplateSlides(
    workflowTemplate,
    mergedAnswers as any,
  ).flatMap(slide => slide.children);

  if (isResideAdmin) {
    const enrich = (node: any): boolean => {
      if (!node) return false;
      if (node.id === "checklist" && Array.isArray(node.children)) {
        node.children = [
          ...node.children,
          INCLUDE_IN_AUDIT_LOG_BLOCK,
        ] as typeof node.children;
        return true;
      }
      const kids = [...(Array.isArray(node.children) ? node.children : [])];
      for (const k of kids) if (enrich(k)) return true;
      return false;
    };

    for (const block of extractedBlocks) {
      if (enrich(block)) break;
    }
  }

  return extractedBlocks;
};

export const getWorkflowNavItems = ({
  workflowType,
  workflowLabel,
  workflowBlocks,
  answers,
  isResideAdmin = false,
}: {
  workflowType: string;
  workflowLabel: string;
  workflowBlocks: ReadonlyArray<any>;
  answers: Record<string, unknown>;
  isResideAdmin?: boolean;
}): WorkflowNavItem[] => {
  const blockItems = filterVisibleFacilitySettingsBlocks(
    workflowBlocks,
    answers,
  ).map(block => ({
    id: makeWorkflowBlockSectionId(workflowType, String(block.id)),
    label: getFacilitySettingsBlockLabel(block),
  }));

  const downloadEmptyPacketItem = {
    id: makeWorkflowDownloadEmptyPacketSectionId(workflowType),
    label: getWorkflowDownloadEmptyPacketTitle(workflowLabel),
  };

  if (!isResideAdmin) {
    return [...blockItems, downloadEmptyPacketItem];
  }

  return [
    ...blockItems,
    {
      id: makeWorkflowDocumentCategorySectionId(workflowType),
      label: "Document Upload Category",
    },
    downloadEmptyPacketItem,
  ];
};
